<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('langNew3.gd')}}</div>
            <!-- <span class="link" @click="link">{{$t('xbsg.wdsg')}}</span> -->
        </div>
        <ul class="tab-ul">
          <li class="tab-li" :class="{active: tabIdx == 0}" @click="tab(0)">{{$t('hyjy.qb')}}</li>
          <li class="tab-li" :class="{active: tabIdx == 1}" @click="tab(1)">{{$t('langNew3.gdlx1')}}</li>
          <li class="tab-li" :class="{active: tabIdx == 2}" @click="tab(2)">{{$t('langNew3.gdlx2')}}</li>
          <li class="tab-li" :class="{active: tabIdx == 3}" @click="tab(3)">{{$t('langNew3.gdlx3')}}</li>
        </ul>
        <div class="cotainer" @scroll="listenScroll">
          <ul class="ul-box">
            <li class="li" v-for="(item,index) in list" :key="index">
              <div class="li-head">
                <img class="img" :src="item.manager_photo" alt="">
                <div>
                  <div class="name ellipse">{{item.manager}}</div>
                  <div class="name2 ellipse">{{item.name}}</div>
                </div>
              </div>
              <div class="li-mid">
                <div class="li-lt">
                  <div class="t1">{{$t('langNew3.npjsy')}}</div>
                  <div class="t2">{{item.year_profit}}</div>
                </div>
                <!-- <div class="li-lt">
                  <div class="t1">3 Day {{$t('收益')}}</div>
                  <div class="t2">+{{item.day3_profit}}%</div>
                </div>
                 <div class="li-lt">
                  <div class="t1">7 Day {{$t('收益')}}</div>
                  <div class="t2">+{{item.day7_profit}}%</div>
                </div>
                <div class="li-lt">
                  <div class="t1">14 Day {{$t('收益')}}</div>
                  <div class="t2">+{{item.day14_profit}}%</div>
                </div>
                <div class="li-lt">
                  <div class="t1">30 Day {{$t('收益')}}</div>
                  <div class="t2">+{{item.day30_profit}}%</div>
                </div>
                <div class="li-lt">
                  <div class="t1">60 Day {{$t('收益')}}</div>
                  <div class="t2">+{{item.day60_profit}}%</div>
                </div>
                <div class="li-lt">
                  <div class="t1">180 Day {{$t('收益')}}</div>
                  <div class="t2">+{{item.day180_profit}}%</div>
                </div> -->
                <div class="line-box"></div>
              </div>
              <ul class="li-foot">
                <li class="li-item">
                  <div class="li-t1">{{$t('langNew3.gtrs')}}</div>
                  <div class="li-t2">{{item.trade_count}}</div>
                </li>
                <li class="li-item">
                  <div class="li-t1">{{$t('langNew3.hbl')}}</div>
                  <div class="li-t2 li-rate">{{item.day_profit}}</div>
                </li>
                <li class="li-item">
                  <div class="li-t1 text-right">{{$t('langNew3.gtje')}}</div>
                  <div class="li-t2 text-right">{{item.trade_amount}}</div>
                </li>
              </ul>
              <div class="gd-btn" @click="show(item.id,item)">{{$t('langNew3.gt')}}</div>
            </li>
            <!-- <li class="li">
              <div class="li-head">
                <img class="img" src="@/assets/USDT.png" alt="">
                <div>
                  <div class="name">Angella</div>
                  <div class="name2">pernod Ricard</div>
                </div>
              </div>
              <div class="li-mid">
                <div class="li-lt">
                  <div class="t1">{{$t('langNew3.npjsy')}}</div>
                  <div class="t2">+9.59%</div>
                </div>
                <div class="line-box"></div>
              </div>
              <ul class="li-foot">
                <li class="li-item">
                  <div class="li-t1">{{$t('langNew3.gtrs')}}</div>
                  <div class="li-t2">3868</div>
                </li>
                <li class="li-item">
                  <div class="li-t1">{{$t('langNew3.hbl')}}</div>
                  <div class="li-t2 li-rate">3868</div>
                </li>
                <li class="li-item">
                  <div class="li-t1 text-right">{{$t('langNew3.gtje')}}</div>
                  <div class="li-t2 text-right">3868</div>
                </li>
              </ul>
              <div class="gd-btn" @click="show()">{{$t('langNew3.gt')}}</div>
            </li> -->
          </ul>
          <!-- 暂无数据 -->
          <div class="null-box" v-show="isNoData">
            <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
            <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
            <p class="text">{{$t('zwsj.title')}}</p>
          </div>
        </div>
        <!-- 弹窗 -->
        <div class="mask" v-show="isMask"></div>
        <div class="alert-box" v-show="isMask">
          <div class="alert-title">{{$t('langNew3.gt')}}</div>
          <div class="alert-num-box">
            <input class="alert-num" v-model="amount" :placeholder="limitNum" type="text">
            <div class="all" @click="all">{{$t('hyjy.qb')}}</div>
          </div>
          <ul class="sy-box">
            <li class="sy-li" v-for="(item,index) in dayList" :class="{active: curDay == item.day}" @click="selectDay(item.day,item.amount_min,item.amount_max)" :key="index">
              <div class="t1">{{item.day}} Day</div>
              <!-- <div class="t2">{{item.amount_min}}-{{item.amount_max}}</div> -->
            </li>
            <!-- <li class="sy-li" :class="{active: curDay == 7}" @click="selectDay(7)">
              <div class="t1">7 Day</div>
              <div class="t2">{{syData.day7_profit}}%</div>
            </li>
            <li class="sy-li" :class="{active: curDay == 14}" @click="selectDay(14)">
              <div class="t1">14 Day</div>
              <div class="t2">{{syData.day14_profit}}%</div>
            </li>
            <li class="sy-li" :class="{active: curDay == 30}" @click="selectDay(30)">
              <div class="t1">30 Day</div>
              <div class="t2">{{syData.day30_profit}}%</div>
            </li>
            <li class="sy-li" :class="{active: curDay == 60}" @click="selectDay(60)">
              <div class="t1">60 Day</div>
              <div class="t2">{{syData.day60_profit}}%</div>
            </li>
            <li class="sy-li" :class="{active: curDay == 180}" @click="selectDay(180)">
              <div class="t1">180 Day</div>
              <div class="t2">{{syData.day180_profit}}%</div>
            </li> -->
          </ul>
          <div class="text">{{$t('jghy.kyye')}}{{kyMoney | toFixed4}} USD</div>
          <div class="btn-box">
            <div class="btn btn1" @click="cancle">{{$t('取消')}}</div>
            <div class="btn btn2" @click="sure">{{$t('确认')}}</div>
          </div>
        </div>
        <!-- 返回顶部 -->
        <img id="goTop" v-if="theme" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/theme/goTop_white.png" alt="">
        <img id="goTop" v-else class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/goTop.png" alt="">
    </div>
</template>

<script>
export default {
    name: 'follow',
    data () {
        return {
          token: '',
          tabIdx: 0,
          id: '',
          isNoData: false,
          amount: '',
          kyMoney: '',
          list: [],
          syData: {},
          curDay: 0,
          isMask: false,
          dayList: [],
          limitNum: '',
          isGoTOP: false,
          curDataLength: 10,
          theme: false,
          page: 1,
          count: 1
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.token = localStorage.getItem('token') || '';
    },
    mounted() {
      this.getStrategyList();
      this.getAsset();
      this.getStrategyLimit();
    },
    methods: {
      back(){
        this.$router.push('/index');
      },
      selectDay(day,min,max){
        this.curDay = day;
        this.limitNum = min + '-' + max;
      },
      tab(idx){
        this.tabIdx = idx;
        this.list = [];
        this.page = 1;
        this.getStrategyList();
      },
      getAsset(){
         this.$ajax.get('/web/getAsset2',{}).then((res) => {
            if(res.data.code == 0){
              let resData = res.data.data;
              this.money = (Number(resData.totalMoney)).toFixed(4);
              this.kyMoney = resData.list.filter((item) =>{
                  return item.currency == 'USDT';
              })[0].positions;

            }else{
              this.$router.push('/login');
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      getStrategyList(){
        let params = {
          type: this.tabIdx,
          page: this.page
        }
        this.$ajax.get('/web/getStrategyList',{params}).then((res) => {
          let resData = res.data.data.data;
          if(resData.length > 0){
            this.list = this.list.concat(resData);
            this.curDataLength = resData.length;
            this.isNoData = false;
          }else{
            this.curDataLength = resData.length;
            this.isNoData = true;
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      getStrategyLimit(){
        this.$ajax.get('/web/getStrategyLimit').then((res) => {
          let resData = res.data.data;
          if(resData.length > 0){
            this.dayList = resData;
            this.curDay = resData[0].day;
            this.limitNum =  resData[0].amount_min + '-' +  resData[0].amount_max;
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      show(id,item){
        this.id = id;
        this.syData = item;
        this.isMask = !this.isMask;
      },
      sure(){
        let params = {
          token: this.token,
          id: this.id,
          amount: this.amount,
          day: this.curDay
        }
        if(!this.amount || this.amount <= 0){
          this.$toast.center(this.$t('xbsg.qsrsl'));
          return;
        }
        if(this.count == 1){
            this.count = 0;
        }else{
            return false;
        }
        this.$ajax.get('/web/buyStrategy',{params}).then((res) => {
          let resData = res.data;
          if(resData.code == 1){
              this.count = 1;
              this.$toast.center(resData.message);
          }else if(resData.code == 1000){
              this.$toast.center(resData.message);
          }else{
            setTimeout(()=>{
              this.count = 1;
              this.$toast.center(resData.message);
              this.$router.push('/records?type=2')
            },1000)
          }
        }).catch(function(err){
            console.log(err)
        })
        // this.$router.push({ path: '/subscribe', query: { id: id } })
      },
      all(){
        this.amount = this.kyMoney;
      },
      cancle(){
        this.isMask = false;
      },
      listenScroll(e) {  //监听滚动
            let ele = e.srcElement ? e.srcElement : e.target;
            if(ele.scrollTop > 200){
                this.isGoTOP = true
            }else{
                this.isGoTOP = false
            }
            if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength > 0){
                  this.page ++;
                  this.getStrategyList(this.tabIdx);
                }
            }
      },
      goTop(){
        $('.cotainer').animate({scrollTop:'0px'},'slow');
      },
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .head .link{
        position: absolute;
        top: 50%;
        right: .3rem;
        padding: .12rem .36rem;
        color: #000;
        font-size: .45rem;
        transform: translateY(-50%);
    }
    .tab-ul{
      position: absolute;
      top: 1.6rem;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      padding: 0 .28rem;
      box-sizing: border-box;
    }
    .tab-ul .tab-li{
      padding: .3rem .4rem .3rem .32rem;
      color: #7d7d7d;
      font-size: .48rem;
    }
     .tab-ul .tab-li.active{
       color: #4458ed;
     }
    .cotainer{
        position: absolute;
        left: 0;
        right: 0;
        top: 3.2rem;
        bottom: 0;
        padding: .1rem .4rem;
        background: #f9f9f9;
        box-sizing: border-box;
        overflow-y: scroll;
    }
    .ul-box .li{
      margin-bottom: .5rem;
      padding: .44rem .25rem .4rem;
      background: #fff;
      box-shadow: 0rem 0.15rem 0.38rem 0rem
		rgba(24, 11, 0, 0.18);
	    border-radius: 0.2rem;
    }
  .ul-box .li .li-head{
    display: flex;
    align-items: center;
  }
  .ul-box .li .li-head .img{
    width: 1.25rem;
    height: 1.25rem;
    margin-right: .35rem;
    border-radius: 50%;
    background-color: #8a8a8a;
  }
  .ul-box .li .li-head .name{
    color: #000;
    font-size: .5rem;
  }
  .ul-box .li .li-head .name2{
    padding-top: .12rem;
    color: #8a8a8a;
    font-size: .4rem;
  }
  .ul-box .li .li-mid{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin: .65rem 0 .5rem;
  }
  .ul-box .li .li-mid .li-lt{
    width: 33.33%;
    margin-top: .3rem;
  }
  .ul-box .li .li-mid .t1{
     color: #000;
    font-size: .4rem;
  }
  .ul-box .li .li-mid .t2{
    padding-top: .25rem;
    color: #1a935b;
    font-size: .46rem;
  }
  .ul-box .li .li-mid .kline{
    height: 2.48rem;
  }
  .ul-box .li .li-foot{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ul-box .li .li-foot .li-t1{
    color: #696a6a;
    font-size: .35rem;
  }
  .ul-box .li .li-foot .li-t2{
    margin-top: .34rem;
    color: #060610;
    font-size: .46rem;
    font-weight: bold;
  }
  .ul-box .li .li-foot .li-rate{
    color: #1a935b;
  }
  .ul-box .li .gd-btn{
    height: 1.14rem;
    margin-top: .7rem;
    color: #fff;
    font-size: .4rem;
    line-height: 1.14rem;
    background: #4458ed;
    border-radius: 0.55rem;
    text-align: center;
  }
  /* 弹窗 */
  .alert-box{
    position: absolute;
    left: .48rem;
    right: .48rem;
    top: 50%;
    z-index: 1000;
    padding: .5rem .5rem .6rem;
    background: #fff;
    box-sizing: border-box;
    border-radius: 0.5rem;
    transform: translateY(-50%);
  }
  .alert-box .alert-title{
    color: #000;
    font-size: .5rem;
    padding: .2rem 0 .5rem;
    text-align: center;
  }
  .alert-box .alert-num-box{
    display: flex;
    align-items: center;
    height: 1.6rem;
    padding: 0 .4rem;
    border-radius: 0.36rem;
    border: solid 0.01rem #b5b5b5
  }
  .alert-box .alert-num-box .alert-num::placeholder{
    font-size: .42rem;
  }
  .alert-box .alert-num-box .alert-num{
    flex: 1;
    color: #000;
    font-size: .45rem;
  }
  .alert-box .alert-num-box .all{
    color: #484eff;
    font-size: .45rem;
  }
  .alert-box .text{
    padding: .4rem 0 .7rem;
    color: #000;
    font-size: .4rem;
  }
  .alert-box .btn-box{
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .alert-box .btn-box .btn{
    width: 3.92rem;
    height: 1.2rem;
    color: #000;
    font-size: .42rem;
    line-height: 1.2rem;
    border-radius: 0.6rem;
    border: solid 0.01rem #000;
    text-align: center;
  }
  .alert-box .btn-box .btn2{
    color: #fff;
    border: 1px solid transparent;
    background: #4458ed;
  }
  .alert-box .sy-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: .3rem;
  }
  .alert-box .sy-box .sy-li{
    width: 30%;
    margin: 0 .1rem .2rem 0;
    padding: .1rem;
    color: #000;
    border-radius: 0.36rem;
    border: solid 0.01rem #b5b5b5;
    box-sizing: border-box;
    text-align: center;
  }
  .alert-box .sy-box .sy-li.active{
    color: #fff;
    background: #4458ed;
  }
  .alert-box .sy-box .sy-li:nth-of-type(3n){
    margin-right: 0;
  }
  .alert-box .sy-box .sy-li .t1{
    font-size: .35rem;
  }
  .alert-box .sy-box .sy-li .t2{
    margin-top: .1rem;
    font-size: .35rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/follow.vue